export const GET_CLIENT_STATUS_OPTIONS_FAILURE = 'GET_CLIENT_STATUS_OPTIONS_FAILURE';
export const GET_CLIENT_STATUS_OPTIONS_REQUEST = 'GET_CLIENT_STATUS_OPTIONS_REQUEST';
export const GET_CLIENT_STATUS_OPTIONS_SUCCESS = 'GET_CLIENT_STATUS_OPTIONS_SUCCESS';

export const GET_INDUSTRY_OPTIONS_FAILURE = 'GET_INDUSTRY_OPTIONS_FAILURE';
export const GET_INDUSTRY_OPTIONS_REQUEST = 'GET_INDUSTRY_OPTIONS_REQUEST';
export const GET_INDUSTRY_OPTIONS_SUCCESS = 'GET_INDUSTRY_OPTIONS_SUCCESS';

export const GET_CLIENT_POLICY_STATUS_OPTIONS_FAILURE = 'GET_CLIENT_POLICY_STATUS_OPTIONS_FAILURE';
export const GET_CLIENT_POLICY_STATUS_OPTIONS_REQUEST = 'GET_CLIENT_POLICY_STATUS_OPTIONS_REQUEST';
export const GET_CLIENT_POLICY_STATUS_OPTIONS_SUCCESS = 'GET_CLIENT_POLICY_STATUS_OPTIONS_SUCCESS';

export const GET_ALL_ENUMERATIONS_FAILURE = 'GET_ALL_ENUMERATIONS_FAILURE';
export const GET_ALL_ENUMERATIONS_REQUEST = 'GET_ALL_ENUMERATIONS_REQUEST';
export const GET_ALL_ENUMERATIONS_SUCCESS = 'GET_ALL_ENUMERATIONS_SUCCESS';

export const GET_ALL_ACTIVE_ENUMERATIONS_FAILURE = 'GET_ALL_ACTIVE_ENUMERATIONS_FAILURE';
export const GET_ALL_ACTIVE_ENUMERATIONS_REQUEST = 'GET_ALL_ACTIVE_ENUMERATIONS_REQUEST';
export const GET_ALL_ACTIVE_ENUMERATIONS_SUCCESS = 'GET_ALL_ACTIVE_ENUMERATIONS_SUCCESS';

export const GET_ALL_PROVINCES_FAILURE = 'GET_ALL_PROVINCES_FAILURE';
export const GET_ALL_PROVINCES_REQUEST = 'GET_ALL_PROVINCES_REQUEST';
export const GET_ALL_PROVINCES_SUCCESS = 'GET_ALL_PROVINCES_SUCCESS';

export const GET_ALL_WEIGHT_TYPES_FAILURE = 'GET_ALL_WEIGHT_TYPES_FAILURE';
export const GET_ALL_WEIGHT_TYPES_REQUEST = 'GET_ALL_WEIGHT_TYPES_REQUEST';
export const GET_ALL_WEIGHT_TYPES_SUCCESS = 'GET_ALL_WEIGHT_TYPES_SUCCESS';

export const GET_ALL_SALE_TYPES_FAILURE = 'GET_ALL_SALE_TYPES_FAILURE';
export const GET_ALL_SALE_TYPES_REQUEST = 'GET_ALL_SALE_TYPES_REQUEST';
export const GET_ALL_SALE_TYPES_SUCCESS = 'GET_ALL_SALE_TYPES_SUCCESS';

export const GET_ALL_CURRENCIES_FAILURE = 'GET_ALL_CURRENCIES_FAILURE';
export const GET_ALL_CURRENCIES_REQUEST = 'GET_ALL_CURRENCIES_REQUEST';
export const GET_ALL_CURRENCIES_SUCCESS = 'GET_ALL_CURRENCIES_SUCCESS';

export const GET_ALL_COUNTRIES_FAILURE = 'GET_ALL_COUNTRIES_FAILURE';
export const GET_ALL_COUNTIRES_REQUEST = 'GET_ALL_COUNTIRES_REQUEST';
export const GET_ALL_COUNTRIES_SUCCESS = 'GET_ALL_COUNTRIES_SUCCESS';
